// userReducer.js
// This will help shape the user information in our application

export const userInitialState = {
  currentUser: null,
  loading: false,
  loggingOut: false,
  error: null,
};

export const UserActionTypes = {
  SESSION_FETCH_START: "USER/SESSION_FETCH_START",
  SESSION_FETCH_SUCCESS: "USER/SESSION_FETCH_SUCCESS",
  SESSION_FETCH_FAILURE: "USER/SESSION_FETCH_FAILURE",
  LOGOUT_SUCCESS: "USER/LOGOUT_SUCCESS",
  LOGIN_START: "USER/LOGIN_START",
  LOGIN_SUCCESS: "USER/LOGIN_SUCCESS",
  LOGIN_FAILURE: "USER/LOGIN_FAILURE",
  FIRST_LOGIN_SUCCESS: "USER/FIRST_LOGIN_SUCCESS",
  SESSION_VALIDATION_START: "USER/SESSION_VALIDATION_START",
  SESSION_VALIDATION_SUCCESS: "USER/SESSION_VALIDATION_SUCCESS",
  SESSION_VALIDATION_FAILURE: "USER/SESSION_VALIDATION_FAILURE",
  LOGOUT_START: "USER/LOGOUT_START",
};

export const userReducer = (state, action) => {
  switch (action.type) {
    case UserActionTypes.SESSION_FETCH_START:
    case UserActionTypes.LOGIN_START:
      return { ...state, loading: true, error: null };

    case UserActionTypes.SESSION_FETCH_SUCCESS:
    case UserActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: null,
      };

    case UserActionTypes.SESSION_FETCH_FAILURE:
    case UserActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, // This will be null for missing sessions, or error message for real errors
        currentUser: null,
      };

    case UserActionTypes.FIRST_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: null,
      };

    // Session validation, which will be happening every 5 minutes, timer settings will be in the constants file, while the landing page will hold the useEffect funtion.
    case UserActionTypes.SESSION_VALIDATION_START:
      return { ...state, loading: false, error: null };
    case UserActionTypes.SESSION_VALIDATION_SUCCESS:
      return {
        ...state,
        loading: false,
        // Don't update currentUser, only confirming the session is valid.
      };
    case UserActionTypes.SESSION_VALIDATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentUser: null,
      };
    case UserActionTypes.LOGOUT_START:
      return { ...state, loggingOut: true, error: null }; // Clear errors on logout start
    case UserActionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        currentUser: null,
        loading: false,
        loggingOut: false,
        error: null,
      };
    default:
      return state;
  }
};
